module.exports = __webpack_public_path__ + "media/images/sales/set/eyecatch-set-02-7d0d5a3160bec8497748f34876a654b8.svg";